import { useDispatch } from 'react-redux';

// TODO upgrade redux to make it correctly work https://redux.js.org/usage/usage-with-typescript
// eslint-disable-next-line @typescript-eslint/no-explicit-any,import/prefer-default-export
export const useAppDispatch: any = useDispatch;
